export default "__VITE_ASSET__B$vsnqsK__"